import React, { useMemo, useCallback } from 'react';
import { IconInfo } from '@ace/react-icons';
import styles from 'assets/css/Card.module.css';
import overlayStyles from 'assets/css/ToolTipOverlay.module.css';
import { useOverlayToggle, RenderRawHTML } from '@ace/react-utilities';

export default function CardTool(props) {
    const { showOverlay, toggleOverlay, overlayRef } = useOverlayToggle();

    const { tool } = props;

    const handleToolClick = useCallback(() => {
        toggleOverlay();
    }, [toggleOverlay]);

    const OverlayContent = useMemo(
        () => (
            <div ref={overlayRef} className={`${overlayStyles.overlayWrap} ${overlayStyles.showOverlay}`}>
                <div>
                    <div className={overlayStyles.overlayClose} onClick={() => handleToolClick()}>x</div>
                    {RenderRawHTML(tool.ToolDescription)}
                </div>
            </div>
        ), [tool.ToolDescription, handleToolClick, overlayRef]
    );

    return (
        <div>
            {useMemo(
                () => (
                    <i className={styles.toolIconWrap} onClick={() => handleToolClick()} title="Info">
                        <IconInfo />
                    </i>
                ), [handleToolClick]
            )}
            <div>
                {showOverlay ? (OverlayContent) : false}
            </div>
        </div>
    )
}
